import React, { useEffect, useState } from "react";
import StructureStyle from "./structure.module.css";
import { Row, Col, Card } from "antd";
import PcaTable from "./component/PCATable";
import PcaScatter from "./component/PCAScatter";
import PhylogeneticTree from "./component/Tree";
import StackedBarChart from "./component/StackBar";
function Structure() {
  const [selectedSamples, setSelectedSamples] = useState([]);
  const [tableData, setTableData] = useState([]);
  return (
    <div className={StructureStyle.Structure_app}>
      <Row gutter={[16, 16]} style={{ width: "90%", margin: "10px auto" }}>
        <Col span={24}>
          <Card
            title="Sample Information Table"
            style={{ width: "100%", margin: "10px auto" }}
            bodyStyle={{ height: "450px", padding: "12px" }}
          >
            <PcaTable
              onSelectionChange={setSelectedSamples}
              onDataLoaded={setTableData}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card
            title="PCA"
            className="dashboard-card"
            bodyStyle={{ height: "600px", padding: "12px" }}
          >
            <PcaScatter
              selectedSamples={selectedSamples}
              tableData={tableData}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card
            title="Phylogenetic Tree"
            className="dashboard-card"
            bodyStyle={{ height: "600px", padding: "10px" }}
          >
            <PhylogeneticTree
              selectedSamples={selectedSamples}
              tableData={tableData}
            />
          </Card>
        </Col>
        <Col span={24}>
          <Card
            title="Population Structure"
            className="dashboard-card"
            bodyStyle={{ height: "400px", padding: "12px" }}
          >
            <StackedBarChart
              selectedSamples={selectedSamples}
              tableData={tableData}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Structure;
